import * as React from 'react';
import {TaskProgress} from 'components/TaskProgress';
import {Helmet} from 'react-helmet';

/**
 * The task progress page
 * @constructor
 */
export default function TaskProgressPage(): React.ReactElement {
  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Выполнение задания</title>
      </Helmet>
      <TaskProgress />
    </React.Fragment>
  );
}
